import { render, staticRenderFns } from "./ClassGroupCompetitionSummary.vue?vue&type=template&id=5c65de82&scoped=true"
import script from "./ClassGroupCompetitionSummary.vue?vue&type=script&lang=js"
export * from "./ClassGroupCompetitionSummary.vue?vue&type=script&lang=js"
import style0 from "./ClassGroupCompetitionSummary.vue?vue&type=style&index=0&id=5c65de82&prod&scoped=true&lang=css"
import style1 from "./ClassGroupCompetitionSummary.vue?vue&type=style&index=1&id=5c65de82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c65de82",
  null
  
)

export default component.exports